<template>
  <aside class="spa-reservation-sidebar">
    <template v-if="isReservationCancelled">
      <div
        class="spa-reservation-sidebar__section"
        :class="{ '--cancelled': isReservationCancelled }"
      >
        <h3 class="spa-reservation-sidebar__title">
          {{ tc('spaSoft.reservationdetails.cancelDetails.contactUsTitle') }}
        </h3>
        <p
          class="spa-reservation-sidebar__text"
          :class="{ '--cancelled': isReservationCancelled }"
          v-html="contactUsDescription"
        />
      </div>
    </template>
    <template v-else>
      <picture
        v-lazyload="{
          src: `${reservationDetailsData.propertyData.imageSrc}`,
          set: [
            { width: '720', height: '405', breakpoint: 'xs' },
            { width: '1024', height: '576', breakpoint: 'md' }
          ],
          fit: 'crop',
          align: 'center',
        }"
        class="image-wrapper spa-reservation-sidebar__image"
      >
        <img
          class="image"
          src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
          :alt="reservationDetailsData.propertyData.facilityName"
        >
      </picture>
      <div class="spa-reservation-sidebar__section">
        <div class="spa-reservation-sidebar__section-policies">
          <div v-html="reservationDetailsData.propertyData.reservationDetailsPolicies" />

          <div v-html="reservationDetailsData.propertyData.cancellationDetailsPolicies" />
        </div>

        <spa-cancel-modal
          type="booking"
        >
          <button
            slot-scope="{ activate }"
            type="button"
            class="spa-reservation-sidebar__cancel-btn"
            @click="activate"
            @keydown.space.prevent="activate"
            @keydown.enter.prevent="activate"
          >
            {{ tc('spaSoft.reservationdetails.cancelBookingCta') }}
          </button>
        </spa-cancel-modal>
      </div>
    </template>
  </aside>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import SpaCancelModal from '../spa-reservation-modals/spa-cancel-modal.vue'

  export default {
    name: 'SpaReservationSidebar',
    components: {
      SpaCancelModal
    },
    computed: {
      ...mapState('spaSoft', ['reservationDetailsData']),
      ...mapGetters('spaSoft', ['isReservationCancelled']),
      ...mapState('i18n', ['translations']),
      ...mapGetters('i18n', ['tc']),
      contactUsDescription() {
        const phone = `<a href="tel:${this.reservationDetailsData?.propertyData?.phone}">${this.reservationDetailsData?.propertyData?.phone}</a>`
        return this.translations?.spaSoft?.reservationdetails?.cancelDetails?.contactUsDescription
          .replace('{{spaPhoneNumber}}', phone) ?? ''
      }
    },
  }
</script>
